module.exports = __webpack_public_path__ + "img/index_title_banner.3054ccf3.png";